
  // ═══════════════════════════════════════════════════════════════
  // VARIABLES À CUSTOMISER POUR CHAQUE PAGE
  // ═══════════════════════════════════════════════════════════════
    const modelDefs = [

    { // 0 – chomo_complet_1M3_V3
      url:        "./assets/massou/models/gariotte_2_nimbuscut_250k_clean_14-10.sog",
      posX: 0,        posY: 0,        posZ: 0,
      rotXDeg: 0,     rotYDeg: 0,     rotZDeg: 0,
      scale: 1,
      localOffX: 0,   localOffY: 0,   localOffZ: 0,
    }
  ];

    const models       = modelDefs.map(m => m.url);
  const modelsAmount = models.length;

  const config_models = {
    lieuCible:    null,
    meshURL:      null,
    planURL:      '',
    curvesURL:    '',
    modelsAmount,
    modelURL:     models,

    camPosX: -15,   camPosY: 15,    camPosZ: -15,
    camRotX: 0,    camRotY: 0,     camRotZ: 0,
    camTargetX: 0, camTargetY: 0, camTargetZ: 0,
    camMinDistance: 0.1,
    camMaxDistance: 100,
    camDampingFactor: 1,

    bgColor: "#ffffff",

    modelPosX:      modelDefs.map(m => m.posX),
    modelPosY:      modelDefs.map(m => m.posY),
    modelPosZ:      modelDefs.map(m => m.posZ),
    modelRotXDeg:   modelDefs.map(m => m.rotXDeg),
    modelRotYDeg:   modelDefs.map(m => m.rotYDeg),
    modelRotZDeg:   modelDefs.map(m => m.rotZDeg),
    modelScale:     modelDefs.map(m => m.scale),
    modelLocalOffX: modelDefs.map(m => m.localOffX),
    modelLocalOffY: modelDefs.map(m => m.localOffY),
    modelLocalOffZ: modelDefs.map(m => m.localOffZ),
  };

  // ═══════════════════════════════════════════════════════════════

   const config_plan = {
    showPlan:           false,
    planMeshInFront:    false,
    planScale:          1,
    planMaterialOpacity: 1.0,
    planPosX:  0,
    planPosY:  0,
    planPosZ:  0,
    planRotX:  0,
    planRotY:  0,
    planRotZ:  0
  }; 

    const config_curves = {
    showCurves: false,
    elevation_step: 0,        // Vertical spacing between each contour line (Three.js units)
    curves_scale: 0,
    curvesWidth: 1,
    curvesPosX:   0,
    curvesPosY:   0,
    curvesPosZ:   0,
    curvesRotX:   0,
    curvesRotY:   0,
    curvesRotZ:  0
  };
  // ═══════════════════════════════════════════════════════════════
  
  const config_interface = {
  showInterface: false,
  showCross: false
};
  // ═══════════════════════════════════════════════════════════════

  import { initViewer } from './spark_viewer_v2.js';
  initViewer({ ...config_models, ...config_plan, ...config_curves, ...config_interface });
